import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-md-12 flex-container" }

import HeaderLogo from "@/components/common/headerLogo.vue";
import BrandPattern from "@/components/prospect/brandPattern/brandPattern2.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'tsaSetupHeader',
  props: {
    dynHeight: {},
    windowHeight: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "col-md-12",
    style: _normalizeStyle({ 'min-height': _ctx.dynHeight })
  }, [
    _createVNode(HeaderLogo, {
      "page-type": '1',
      light_logo: true
    }),
    _createElementVNode("div", {
      class: "row no-padding main-body h-100",
      style: _normalizeStyle({ height: _ctx.windowHeight })
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(BrandPattern, { page: "TSASetup" })
      ])
    ], 4)
  ], 4))
}
}

})